export default "__VITE_ASSET__DrGH_qs3__"